function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  id: "Group_4564",
  "data-name": "Group 4564",
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24"
}, props), /*#__PURE__*/React.createElement("path", {
  id: "Path_2372",
  "data-name": "Path 2372",
  d: "M24 0H0v24h24z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_2373",
  "data-name": "Path 2373",
  d: "M17.172 7l-2.536 2.536 1.414 1.414L21 6l-4.95-4.95-1.414 1.414L17.172 5H10a8 8 0 000 16h9v-2h-9a6 6 0 010-12z",
  transform: "translate(1)",
  fill: "#fff"
})));